import React, { Component } from "react";

class ShopToolBar extends Component {
  render() {
      return <div />;
    //  (
    //  <div className="shop-toolbar padding-bottom-1x mb-2">
    //    <div className="column">
    //      <div className="shop-sorting">
    //        <label htmlFor="sorting">Sort by:</label>
    //        <select className="form-control" id="sorting">
    //          <option>Popularity</option>
    //          <option>Low - High Price</option>
    //          <option>High - Low Price</option>
    //          <option>Avarage Rating</option>
    //          <option>A - Z Order</option>
    //          <option>Z - A Order</option>
    //        </select>
    //        <span className="text-muted">Showing:&nbsp;</span>
    //        <span>1 - 12 items</span>
    //      </div>
    //    </div>
    //    <div className="column">
    //      <div className="shop-view">
    //        <a className="grid-view active" href="shop-grid-ns.html">
    //          <span />
    //          <span />
    //          <span />
    //        </a>
    //        <a className="list-view" href="shop-list-ns.html">
    //          <span />
    //          <span />
    //          <span />
    //        </a>
    //      </div>
    //    </div>
    //  </div>
    //);
  }
}

export default ShopToolBar;
